import { PropertyConstants } from '../constants/PropertyConstants';

const postingUtils = {
  transformPropertyListingTypeForApi(formData: {
    listingType: keyof typeof PropertyConstants.LISTING_CODES_BY_TYPE;
    propertyType: (typeof PropertyConstants.PROPERTY_TYPES)[keyof typeof PropertyConstants.PROPERTY_TYPES];
    fullAddress: string;
    unitNumber?: string;
    numUnits?: string;
  }) {
    const { LISTING_ENUM_BY_TYPE, PROPERTY_ENUM_BY_TYPE } = PropertyConstants;
    return {
      listingType: LISTING_ENUM_BY_TYPE[formData.listingType],
      propertyType: PROPERTY_ENUM_BY_TYPE[formData.propertyType],
      fullAddress: formData.fullAddress,
      unitNumber: formData.unitNumber,
      numUnits: formData.numUnits,
    };
  },
};

export default postingUtils;
